export default {"src":"/_next/static/media/icon-start-3d.f6443af8.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};